var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.625 7.70833L7.70833 4.625L32.375 29.2917L29.2917 32.375L4.625 7.70833ZM20.0417 7.70833L21.5833 4.625L23.125 7.70833L26.2083 9.25L23.125 10.7917L21.5833 13.875L20.0417 10.7917L16.9583 9.25L20.0417 7.70833ZM7.70833 23.125L9.25 20.0417L10.7917 23.125L13.875 24.6667L10.7917 26.2083L9.25 29.2917L7.70833 26.2083L4.625 24.6667L7.70833 23.125ZM6.16667 13.875L7.70833 15.4167L6.16667 16.9583L4.625 15.4167L6.16667 13.875ZM27.75 15.4167L29.2917 16.9583L27.75 18.5L26.2083 16.9583L27.75 15.4167Z",
    fill: "#6ED33F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardV2);
export default __webpack_public_path__ + "static/media/CardV2.de7fbad3321b4a22d78731e3e6efddc2.svg";
export { ForwardRef as ReactComponent };